export const getHoursFromRouter = (router: string[]): string[] =>
  router.map((route) => route.split(" ")[0]);

export const sortPossibleHoursArray = (array: string[]) =>
  array.sort((a, b) => Number(a.split(":")[0]) - Number(b.split(":")[0]));
